<script lang="ts">
  import { onMount } from "svelte";
  import { track } from "../helpers/mixpanel";

  onMount(() => {});
</script>

<div class="container">
  <img src="static/assets/use-desktop.png" alt="use desktop" />
</div>

<style>
  .container {
    display: flex;
    flex: 1;
    background-color: var(--rekki-neutral-01);
    height: 100%;
  }

  img {
    object-fit: contain;
    display: block;
    width: 100%;
    height: 100%;
  }
</style>
